const paymentTestRoutes = {
	path: 'payment-test',
	name: 'payment-test',
	component: () => import('./pages/payment-test.vue'),
	meta: {
		title: 'Payment API Test',
	},
};

export { paymentTestRoutes };
